<template>
  <div class="text-filter-container">
    <el-radio-group v-model="isCategory">
      <el-radio :label="true">分类分组</el-radio>
      <el-radio :label="false" :style="{ marginTop: '10px' }">一般分组</el-radio>
    </el-radio-group>
  </div>
</template>

<script>
import { getRowDefaultCategoryMode } from '@/lib/utils';

export default {
  data() {
    return {
      isCategory: false
    };
  },
  props: {
    fieldItem: {
      type: Object,
      required: true
    }
  },
  created() {
    this.isCategory = getRowDefaultCategoryMode(this.fieldItem);
  },
  methods: {
    validateInfo() {
      return { categoryMode: this.isCategory };
    }
  }
};
</script>

<style lang="scss" scoped>
.text-filter-container {
  width: 160px;
  padding: 15px 20px;
}
</style>
